// errors-handler.ts
import { ErrorHandler, Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { LoadingComponent } from '../components/loadingComponent';
import { AlertComponent } from '../components/alertComponent';
import { ServerProvider } from '../providers/server-provider';
import { Platform } from 'ionic-angular';

@Injectable()
export class ErrorsHandler implements ErrorHandler {

    constructor(
        public loading: LoadingComponent,
        public alert: AlertComponent,
        public platform: Platform
    ) { }

    /**
     * Manejador de errores
     * @param error
     */
    handleError(error: Error | HttpErrorResponse) {

        if(error){
            console.log(error);
        }


        //captura errores

        let status = 0;
        let message = "";
        let errorMessage = {
            title: "Error",
            mesage: ""
        };

        if (error instanceof HttpErrorResponse) {
            status = error.status;
            message = error.message;

            //capturar errores de odo
            if (error.error && error.error.error && error.error.error.code) {
                //obtener mensaje del error
                errorMessage.mesage = error.error.error.code;

                //obtener tipo de error
                if (errorMessage.mesage.includes("warning -- WARNING")) {
                    errorMessage.title = "Advertencia";

                    //quitar texto de warning
                    errorMessage.mesage = errorMessage.mesage.replace("warning -- WARNING", "");
                } else if (errorMessage.mesage.includes("warning -- Warning")) {
                    errorMessage.title = "Advertencia";

                    //quitar texto de warning
                    errorMessage.mesage = errorMessage.mesage.replace("warning -- Warning", "");
                }
                else if (errorMessage.mesage.includes("warning -- ERROR")) {
                    errorMessage.title = "Error";

                    //quitar texto de warning
                    errorMessage.mesage = errorMessage.mesage.replace("warning -- ERROR", "");
                }

                if(errorMessage.mesage.includes('Acceso denegado a usuario "demo"')){
                    errorMessage.mesage = errorMessage.mesage.replace('Acceso denegado a usuario "demo"', "Operación no permitida para usuario de demostración.");
                }
            }

        } else {
            message = error.message;
        }


        //Cierra modales de loading
        this.loading.dismissAll();

        switch (status) {

            //Unauthorized
            case 401: {
                ServerProvider.myApp.logout();

                this.alert.openAlertAccept(
                    "Error",
                    "Usuario no válido",
                    null,
                    () => { }
                );

                break;
            }

            //Internal Server Error
            case 500: {

                this.alert.openAlertAccept(
                    errorMessage.title,
                    errorMessage.mesage,
                    null,
                    () => { }
                );

                break;
            }

            //Validation error
            case 422: {

                this.alert.openAlertAccept(
                    errorMessage.title,
                    errorMessage.mesage,
                    null,
                    () => { }
                );

                break;
            }

            //Otros errores
            default: {

                switch (message) {

                    //error server o server caido
                    case "Http failure response for (unknown url): 0 Unknown Error": {
                        this.alert.openAlertAccept("Error", "Error al conectarse con el servidor", null, () => {
                            ServerProvider.myApp.logout();
                        });
                        break;
                    }

                    case "COMPANY-CHANGE": {
                        this.alert.openAlertAccept("Error", "Error al cambiar de compañía", null, () => {
                            window.location.reload();
                        });
                        break;
                    }

                    default: {
                        //otro error sin controlar

                        break;
                    }
                }

                break;
            }
        }
    }

}


// WEBPACK FOOTER //
// ./src/app/errors-handler.ts